import {
	type FetchLedgersSummaryParams,
	type FetchLedgerSummaryByLedgerIdParams,
	type FetchLimitLedgerRemainingParams
} from '@capsicum/common';

import { walletApi } from '.';

export async function fetchLedgerSummaryByLedgerId({ ledgerId, ...params }: FetchLedgerSummaryByLedgerIdParams) {
	return (await walletApi)
		.fetchLedgerSummaryByLedgerId({
			ledgerId,
			...params
		})
		.then(res => res.data);
}

export async function fetchLedgerSummary({ ...params }: FetchLedgersSummaryParams) {
	return (await walletApi)
		.fetchLedgersSummary({
			...params
		})
		.then(res => res.data);
}

export async function fetchLimitLedgerRemaining(params: FetchLimitLedgerRemainingParams) {
	return (await walletApi)
		.fetchLimitLedgerRemaining({
			...params
		})
		.then(res => res.data);
}
